/**
* @GasAlarmTable.vue
* @Description
* @Author JiShaoHua
* @Date 2022/10/21 15:21
**/
<template>
  <div class="table-item-box padding-l-none" style="padding: 10px;">
    <section style="height: 100%;">

      <!-- 表格 -->
      <el-table :data="tableInfos"
                ref="tableInfos"
                stripe
                :class="{'table': true, 'no-pagination': false}"
      >
        <el-table-column v-for="(item, index) in colData" :key="index" :label="item.title" v-if="item.isShow"
                         :min-width="item.minWidth">
          <template v-slot="scope">
                        <span style="white-space: nowrap;"
                              :title="scope.row[item.value]">{{ scope.row[item.value] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!--分页工具条-->
      <Pagination
          :currentPage="pagination.currentPage"
          :total="pagination.total"
          :pageSize="pagination.limit"
          @handleSizeChangeSub="handleSizeChangeSub"
          @handleCurrentChangeSub="handleCurrentChangeSub"
      />

      <!--查询工具条-->
      <el-col style="text-align: left;">
        <el-form :inline="true" :model="filters" ref="filters">
          <el-form-item>
            查询条件：
          </el-form-item>
          <el-form-item prop="sensorTypeId">
            <el-select v-model="filters.sensorTypeId" placeholder="请选择传感器类型" clearable @change="research">
              <el-option v-for="item in gasTypes" :key="item.sensorTypeId" :label="item.sensorType" :value="item.sensorTypeId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="keyword">
            <el-input v-model="filters.keyword" placeholder="请输入传感器名称" clearable @keyup.enter.native="research" :style="{width: '300px'}">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="research"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="duration" class="item-cnt-lhfs-0">
            <el-date-picker
                :picker-options="filters.pickerOptions"
                v-model="filters.alarmDate"
                type="datetimerange"
                range-separator="—"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="报警开始时间"
                end-placeholder="结束时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" trigger="click" @click="research">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>

    </section>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import ApiGas from "@/request/api-gas";

export default {
  name: "GasAlarmTable",
  /**
   * @Description 组件引用
   * @Date 10:32 2022/10/24
   * @Param
   * @Return
   */
  components: {
    Pagination
  },
  props: {
    gasTypes: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  /**
   * @Description 数据定义
   * @Date 14:19 2022/10/24
   * @Param
   * @Return
   */
  data() {
    return {
      filters: {
        sensorType: '',
        keyword: '',
        alarmDate: '',
        sensorTypeId: '',
        orderBy: {
          "createTime": "asc"
        }
      },
      colData: [
        {title: "设备编号", value: "deviceNo", isShow: true, minWidth: "100px"},
        {title: "传感器类型", value: "sensorType", isShow: true, minWidth: "100px"},
        {title: "传感器名称", value: "sensorName", isShow: true, minWidth: "100px"},
        {title: "气体浓度", value: "gasDensity", isShow: true, minWidth: "100px"},
        {title: "报警状态", value: "alarmState", isShow: true, minWidth: "100px"},
        {title: "报警时间", value: "alarmDate", isShow: true, minWidth: "100px"},
        {title: "结束时间", value: "dealTime", isShow: true, minWidth: "100px"},
        {title: "温度", value: "temperature", isShow: true, minWidth: "100px"},
        {title: "湿度", value: "humidity", isShow: true, minWidth: "100px"}
      ],
      colOptions: [], //默认全选
      colSelect: [],
      // 表格信息
      tableInfos: [],
      pagination: {
        total: 0,
        startNum: 0,
        limit: 50,
        currentPage: 1
      }
    }
  },
  computed: {},
  created() {
    this.setDefaultTableTitle();
  },
  mounted() {
    this.searchGasAlarm();
  },
  /**
   * @Description 方法定义
   * @Date 14:21 2022/10/24
   * @Param
   * @Return
   */
  methods: {

    /**
     * @Description 设置默认选中的表头
     * @Date 10:52 2022/10/24
     * @Param
     * @Return
     */
    setDefaultTableTitle() {
      this.colOptions = [];
      this.colSelect = [];
      this.colData.forEach((row, index) => {
        this.colOptions.push(row.title);
        this.colSelect.push(row.title);
      })
    },
    /**
     * @Description 重新搜索
     * @Date 11:04 2022/10/24
     * @Param
     * @Return
     */
    research() {
      this.pagination.total = 0;
      this.pagination.startNum = 0;
      this.searchGasAlarm();
    },
    /**
     * @Description 查询传感器报警
     * @Date 11:04 2022/10/24
     * @Param
     * @Return
     */
    searchGasAlarm() {

      // 开始结束时间
      let startTime = '';
      let endTime = '';

      startTime = this.filters.alarmDate[0];
      endTime = this.filters.alarmDate[1];
      console.log(startTime);
      console.log(endTime);
      this.$request.postJsonRequest(ApiGas.searchSensorAlarmApi, {
        sensorType: this.filters.sensorType,
        sensorTypeId: this.filters.sensorTypeId,
        keyword: this.filters.keyword,
        beginTime: startTime == '' ? 0 : new Date(startTime).getTime(),
        endTime: endTime == '' ? 0 : new Date(endTime).getTime(),
        orderBy: {
          create_time: 'desc'
        },
        total: this.pagination.total,
        startNum: this.pagination.startNum,
        limit: this.pagination.limit
      }).then(result => {

        this.pagination.total = result.total;
            result.rows.forEach((row, index) => {
              if (row.alarmState == 1) {
                row.alarmState = '正常';
              } else if (row.alarmState == 2) {
                row.alarmState = '报警';
              }

              // 报警时间
              if (row.alarmDate != null) {
                row.alarmDate = this.$moment(row.alarmDate).format('YYYY-MM-DD HH:mm:ss');
              }

              // 结束时间
              if (row.dealTime == null) {
                row.dealTime = "  --  ";
              } else {
                row.dealTime = this.$moment(row.dealTime).format('YYYY-MM-DD HH:mm:ss');
              }

            })

        this.tableInfos = result.rows;

      }).catch(error => {
        console.error('查询传感器报警异常', ApiGas.searchSensorRecordApi, error);
      })
    },
    /**
     * @Description 当前页数据改变
     * @Date 11:03 2022/10/24
     * @Param
     * @Return
     */
    handleCurrentChangeSub(val) {
      this.pagination.currentPage = val;
      this.pagination.startNum = this.pagination.limit * (val - 1);
      this.searchGasAlarm();
    },
    /**
     * @Description 页长度改变
     * @Date 11:03 2022/10/24
     * @Param
     * @Return
     */
    handleSizeChangeSub(val) {
      this.pagination.limit = val;
      this.pagination.currentPage = 1;
      this.pagination.startNum = 0;
      this.searchGasAlarm();
    },
    /**
     * @Description 是否选择
     * @Date 11:03 2022/10/24
     * @Param
     * @Return
     */
    checkSelectable(row) {
      return true;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components_pages/gas/GasAlarmTable.vue